import axios from 'axios';
import { DOCUMENTS_IN } from '../constantes';
export const GET_INDOCUMENTS = 'GET_INDOCUMENTS';
export const GET_INDOCUMENT_ID = 'GET_INDOCUMENT_ID'
export const POST_INDOCUMENTS = 'POST_INDOCUMENTS'

export const getInDocuments = () => async dispatch => {
    await axios.get(DOCUMENTS_IN)
        .then((res) => {
            dispatch({
                type: GET_INDOCUMENTS,
                payload: res.data
            })
        })
        .catch((err) => {console.log(err)})
}

export const getInDocumentId = (id) => async dispatch => {
    await axios.get(`${DOCUMENTS_IN}/${id}`)
        .then((res) => {
            dispatch({
                type: GET_INDOCUMENT_ID,
                payload: res.data
            })
        })
        .catch((err) => {console.log(err)})
}

export const postInDocuments = (payload) => async dispatch => {
    try {
        await axios.post(DOCUMENTS_IN, payload)
        .then((res) => {
            dispatch({
                type: POST_INDOCUMENTS,
                payload: res.data
            })
        })
    } catch (error) {
        return console.log(error)
    }
}
